<button
  i18n-matTooltip
  mat-icon-button
  class="close-btn"
  matTooltip="Выход из полноэкранного режима"
  (click)="dialogRef.close()">
  <mat-icon>close</mat-icon>
</button>

<csl-panels-schema
  *ngIf="linkToSchemas"
  [data]="data"
  [fullscreen]="true"
  [linkToSchemas]="linkToSchemas"></csl-panels-schema>
